import tools from './tools';
import commonApi from './commonApi';
import validator from './validator';
var util = {
  ...tools,
  ...commonApi,
  ...validator
};
window.util = util;
export default util;
